import { useEffect } from "react";

function useEscapeKey(onEscape, active = true) {
  useEffect(() => {
    if (!active) return;

    function handleKeyDown(event) {
      if (event.key === "Escape") onEscape();
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onEscape, active]);
}

export default useEscapeKey;
